import { connect } from "react-redux"
import NodeDataView from "./NodeDataView"

const mapStateToProps = (state, props) => ({})

const mapDispatchToProps = (dispatch, props) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(NodeDataView)
